module.exports = __webpack_public_path__ + "img/banner4@2x.ccef2779.png";